export enum TypeOfDeinFlow {
	SCANQR = 'scan_qr',
	SELECT_TABLE = 'select_table'
}
